import React from 'react';
import { useTheme } from 'styled-components';

const ArrowRight = ({ color }) => {
    const theme = useTheme();
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
        React.createElement("g", { clipPath: "url(#clip0_7500_11961)" },
            React.createElement("path", { d: "M10 1.5L20.5 16L10 31", stroke: color !== null && color !== void 0 ? color : theme.colors.arrowColor, strokeWidth: "3.5" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_7500_11961" },
                React.createElement("rect", { width: "32", height: "32", fill: color !== null && color !== void 0 ? color : theme.colors.arrowColor, transform: "matrix(-1 0 0 1 32 0)" })))));
};

export { ArrowRight as default };
//# sourceMappingURL=ArrowRight.mjs.map
